module.exports = __webpack_public_path__ + "static/dicas-melhorar-intelecto-45bf2de6ca4a56f7630d3f79c8547176.jpg";